import Divider from "components/ui/divider"
import Media from "components/ui/media"
import Shimmer from "components/ui/shimmer"

import { GridContainer } from "../products"
import Placeholder from "../products/placeholder"

import FilterAccordionLoading from "./filter-accordion-loading"

const Shimmers = () => (
  <div className="contained-wide">
    {/* <div
      className="aspect-(--base-aspect-ratio) tablet:aspect-(--tablet-aspect-ratio)"
      style={{
        "--base-aspect-ratio": "750 / 200",
        "--tablet-aspect-ratio": "3840 / 564",
      }}
    >
      <Shimmer className="h-full w-full" />
    </div> */}
    <div className="px-16">
      <div className="my-16">
        <Shimmer className="mb-16" style={{ height: "16px", width: "200px" }} />
        <div className="flex justify-between">
          <div className="desktop:w-3/4 w-full">
            <Shimmer
              className="desktop:w-(--desktop-width) w-(--base-width) h-(--base-height) tablet:h-(--tablet-height) widescreen:h-(--widescreen-height) mb-10"
              style={{
                "--base-height": "22px",
                "--base-width": "200px",
                "--desktop-width": "400px",
                "--tablet-height": "24px",
                "--widescreen-height": "28px",
              }}
            />
            <Shimmer
              className="desktop:h-(--desktop-height) h-(--base-height) w-full"
              style={{
                "--base-height": "60px",
                "--desktop-height": "36px",
              }}
            />

            {/* <Media lessThan="desktop">
              <Shimmer
                className="mt-8"
                style={{ height: "12px", width: "300px" }}
              />
            </Media> */}
          </div>

          {/* <Media greaterThanOrEqual="desktop">
            <Shimmer style={{ height: "20px", width: "130px" }} />
          </Media> */}
        </div>
      </div>
      <Divider className="bg-grey-10" />
      <Media className="flex justify-between p-8" lessThan="desktop">
        <Shimmer style={{ height: "20px", width: "70px" }} />
        <Shimmer style={{ height: "20px", width: "135px" }} />
      </Media>
      <div className="flex justify-center">
        <Media className="max-w-215 w-1/4" greaterThanOrEqual="desktop">
          <FilterAccordionLoading />
        </Media>
        <div className="flex-1">
          <GridContainer>
            {[...Array(12)].map((_, i) => (
              <Placeholder index={i} key={`placeholder-${i}`} />
            ))}
          </GridContainer>
        </div>
      </div>
    </div>
  </div>
)

export default Shimmers
